import { PremiumButtonTextModule } from '../premium/button-text/premium-button-text.module';
import { PriceBlockModule } from '../price-block/price-block.module';
import { ButtonModule } from '../controls/button/button.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NormalTutorialModalComponent } from './normal-tutorial-modal/normal-tutorial-modal.component';

@NgModule({
  declarations: [NormalTutorialModalComponent],
  imports: [
    PremiumButtonTextModule,
    PriceBlockModule,
    TranslateModule,
    CommonModule,
    ButtonModule,
  ],
})
export class TutorialModule {}
